import React from 'react';
import {Form, Button, Table, Input, Select, TextArea, Popup, Icon, Header} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { FiltersOnStyle } from '../Professor/ProfessorInputGrades/css';


// attributes
// attributeNames
// availableAttributeNames
export default class ConfigTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
            newEngValue: '',

            newNameErr: false,
            newValueErr: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this._activateEditMode = this._activateEditMode.bind(this);
        this._activateAddMode = this._activateAddMode.bind(this);
        this._cancelAddMode = this._cancelAddMode.bind(this);
        this._cancelEditMode = this._cancelEditMode.bind(this);
        this._saveEditMode = this._saveEditMode.bind(this);
        this._saveAddMode = this._saveAddMode.bind(this);
        this._deleteAttribute = this._deleteAttribute.bind(this);
    }

    componentDidMount() {
        this.props.fetchAttributes();
        this.props.fetchAttributesNames();
    }

    // TODO: set first as selected in availableAttributeNames
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleChange(event, { name, value }) {
        this.setState({
            newNameErr: false,
            newValueErr: false,
            [name]: value
        });
    }
    _activateAddMode() {
        this.setState({
            addMode: true,
            editModeId: null,
            newName: '',
            newValue: '',
            newEngValue: ''
        });
    }
    _activateEditMode(id) {
        const selected = this.props.attributes.find(el => el.id === id);
        this.setState({
            addMode: false,
            editModeId: id,
            newName: selected.name,
            newValue: selected.value,
            newEngValue: selected.translations.length ? selected.translations[0].value : ''
        });
    }
    _cancelAddMode() {
        this.setState({
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
            newNameErr: false,
            newValueErr: false,
        });
    }
    _cancelEditMode() {
        this.setState({
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
            newNameErr: false,
            newValueErr: false,
        });
    }
    _saveAddMode() {
        const { newName, newValue, newEngValue } = this.state;

        if (!newName || !newValue) {
            toast('Niste unijeli sva polja!');
            if (!newName) { this.setState({ newNameErr: true }); } else { this.setState({ newNameErr: false }); }
            if (!newValue) { this.setState({ newValueErr: true }); } else { this.setState({ newValueErr: false }); }
        } else {
            const findSimpleNameAttribute = this.props.availableAttributeNames.find(el => el.key === newName);
            this.props.saveNewAttribute(findSimpleNameAttribute.name, findSimpleNameAttribute.text, newValue, newEngValue);
            this.setState({
                addMode: false,
                editModeId: null,
                newName: '',
                newValue: '',
                newEngValue: '',
                newNameErr: false,
                newValueErr: false,
            });
        }
    }
    _saveEditMode() {
        const { newName, newValue, editModeId, newEngValue } = this.state;
        const findSimpleNameAttribute = this.props.attributeNames.find(el => el.name === newName);
        const { displayName } = findSimpleNameAttribute;
        this.props.saveEditedAttribute(editModeId, newName, displayName, newValue, newEngValue);
        this.setState({
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
        });
    }
    _deleteAttribute(id) {
        this.props.deleteAttribute(id);
        this.setState({
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
        });
    }
    render() {
        const addNewAttributeSelect = (
            <Form>
                <Form.Field
                    required
                    error={this.state.newNameErr}
                    control={Select}
                    clearable
                    value={this.state.newName}
                    onChange={this.handleChange}
                    name="newName"
                    options={this.props.availableAttributeNames}
                    search
                    fluid
                    placeholder="Odaberite atribut"

                />
            </Form>
        );
        const addNewAttributeInput = (
            <Form>
                <Form.Field
                    required
                    error={this.state.newValueErr}
                    control={Input}
                    name="newValue"
                    id="newValue"
                    value={this.state.newValue}
                    onChange={this.handleInputChange}
                />
            </Form>
        );

        const addNewEngAttributeInput = (
            <Form>
                <Form.Field
                    control={Input}
                    name="newEngValue"
                    id="newEngValue"
                    value={this.state.newEngValue}
                    onChange={this.handleInputChange}
                />
            </Form>
        );

        return (
            <div>
                <Table structured celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Atribut</Table.HeaderCell>
                            <Table.HeaderCell colSpan="2">
                                <Header as="h4">
                                    <Header.Content>
                                        Vrijednost
                                    </Header.Content>
                                    <Header.Subheader>B/H/S jezik</Header.Subheader>
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan="2">
                                <Header as="h4">
                                    <Header.Content>
                                        Vrijednost
                                    </Header.Content>
                                    <Header.Subheader>Engleski jezik</Header.Subheader>
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center">
                                <Popup
                                    content="Dodaj atribut"
                                    position="top center"
                                    trigger={
                                        <Button
                                            icon="add"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            onClick={() => this._activateAddMode()}
                                        />}
                                />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {this.props.attributes.map(el =>
                            this.state.editModeId !== el.id ?
                                (<Table.Row>
                                    <Table.Cell verticalAlign="middle">{el.displayName}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan="2">{el.value}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan="2">{el.translations.length ? el.translations[0].value : ''}</Table.Cell>

                                    <Table.Cell textAlign="center" verticalAlign="middle">
                                        <Popup
                                            content="Izmjena"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="pencil"
                                                    size="small"
                                                    color="green"
                                                    onClick={() => this._activateEditMode(el.id)}
                                                />}
                                        />
                                        <Popup
                                            content="Brisanje"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="trash alternate"
                                                    size="small"
                                                    color="red"
                                                    onClick={() => this._deleteAttribute(el.id)}
                                                />}
                                        />
                                    </Table.Cell>
                                </Table.Row>)
                                :
                                (<Table.Row>
                                    <Table.Cell>{el.displayName}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan="2">
                                        <Form>
                                            <Form.Field
                                                control={this.props.studentService ? TextArea : Input}
                                                name="newValue"
                                                value={this.state.newValue}
                                                onChange={this.handleInputChange}
                                                defaultValue={el.value}
                                            />
                                        </Form>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan="2">
                                        <Form>
                                            <Form.Field
                                                control={this.props.studentService ? TextArea : Input}
                                                name="newEngValue"
                                                value={this.state.newEngValue}
                                                onChange={this.handleInputChange}
                                                defaultValue={el.translations.length ? el.translations[0].value : ''}
                                            />
                                        </Form>
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" >
                                        <Popup
                                            content="Sačuvaj"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="check"
                                                    size="small"
                                                    color="blue"
                                                    onClick={this._saveEditMode}
                                                />}
                                        />
                                        <Popup
                                            content="Poništi"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="delete"
                                                    size="small"
                                                    color="red"
                                                    onClick={() => this._cancelEditMode()}
                                                />}
                                        />
                                    </Table.Cell>
                                </Table.Row>))}

                        {this.state.addMode &&
                            <Table.Row >
                                <Table.Cell >{addNewAttributeSelect}</Table.Cell>
                                <Table.Cell colSpan="2">{addNewAttributeInput}</Table.Cell>
                                <Table.Cell colSpan="2">{addNewEngAttributeInput}</Table.Cell>
                                <Table.Cell textAlign="center">
                                    <Popup
                                        content="Sačuvaj"
                                        position="top center"
                                        trigger={
                                            <Button
                                                basic="true"
                                                circular
                                                icon="check"
                                                size="small"
                                                color="blue"
                                                onClick={this._saveAddMode}
                                            />}
                                    />
                                    <Popup
                                        content="Poništi"
                                        position="top center"
                                        trigger={
                                            <Button
                                                basic="true"
                                                circular
                                                icon="delete"
                                                size="small"
                                                color="red"
                                                onClick={this._cancelAddMode}
                                            />}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>
                <ToastContainer hideProgressBar />
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DocumentTemplateConfiguration/ConfigTable.js